import { LegalLayout, COMPANY } from './LegalPage';

export default function PrivacidadPage() {
  return (
    <LegalLayout title="Política de Privacidad" active="privacidad">
      <section>
        <h2>1. Responsable del tratamiento</h2>
        <table>
          <tbody>
            <tr><td>Responsable</td><td>{COMPANY.name}</td></tr>
            <tr><td>CIF</td><td>{COMPANY.cif}</td></tr>
            <tr><td>Domicilio</td><td>{COMPANY.address}</td></tr>
            <tr><td>Contacto DPD</td><td><a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></td></tr>
          </tbody>
        </table>
      </section>

      <section>
        <h2>2. Datos que tratamos y finalidad</h2>
        <p>Tratamos los datos personales que el Usuario nos facilita a través de los formularios del Sitio y del uso del servicio Sera AI, con las siguientes finalidades:</p>
        <table>
          <tbody>
            <tr>
              <td>Gestión de la cuenta</td>
              <td>Nombre, apellidos, dirección de correo electrónico, datos de acceso (gestionados a través de Clerk). Base jurídica: ejecución del contrato (art. 6.1.b RGPD).</td>
            </tr>
            <tr>
              <td>Prestación del servicio</td>
              <td>Datos del catálogo de productos, configuración de búsqueda, histórico de conversaciones y métricas de uso necesarios para prestar las funcionalidades de Sera AI. Base jurídica: ejecución del contrato (art. 6.1.b RGPD).</td>
            </tr>
            <tr>
              <td>Facturación y pagos</td>
              <td>Datos de facturación procesados a través de Stripe. No almacenamos datos de tarjetas de crédito. Base jurídica: cumplimiento de obligación legal (art. 6.1.c RGPD).</td>
            </tr>
            <tr>
              <td>Comunicaciones comerciales</td>
              <td>Correo electrónico para enviar novedades del servicio o actualizaciones de la plataforma, únicamente con consentimiento previo. Base jurídica: consentimiento (art. 6.1.a RGPD).</td>
            </tr>
            <tr>
              <td>Solicitudes de contacto</td>
              <td>Nombre y dirección de correo electrónico facilitados a través del formulario de contacto. Base jurídica: interés legítimo / consentimiento (art. 6.1.a y 6.1.f RGPD).</td>
            </tr>
            <tr>
              <td>Módulo de opiniones</td>
              <td>Cuando el comercio utiliza el módulo de reviews de Sera, trata en nombre del comercio (como encargado del tratamiento) el nombre y correo electrónico del comprador, así como la valoración y comentarios. Base jurídica: ejecución del contrato entre el comercio y su cliente.</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section>
        <h2>3. Plazo de conservación</h2>
        <p>Los datos se conservarán mientras la relación contractual esté vigente y, una vez finalizada, durante los plazos legalmente exigibles (mínimo 5 años para datos fiscales y de facturación, conforme al Código de Comercio). Los datos asociados a comunicaciones comerciales se conservarán hasta que el Usuario retire su consentimiento.</p>
      </section>

      <section>
        <h2>4. Destinatarios y transferencias internacionales</h2>
        <p>Los datos podrán ser comunicados a los siguientes encargados del tratamiento necesarios para la prestación del servicio:</p>
        <ul>
          <li><strong>Clerk Inc.</strong> (Estados Unidos) — gestión de autenticación e identidad. Cuentan con las garantías adecuadas conforme al marco UE-EE. UU. (DPF) o cláusulas contractuales tipo de la Comisión Europea.</li>
          <li><strong>Stripe Inc.</strong> (Estados Unidos) — procesamiento de pagos. Certificado bajo el DPF UE-EE. UU.</li>
          <li><strong>MongoDB Atlas / AWS</strong> — alojamiento de base de datos en región UE (Europa).</li>
          <li><strong>Resend Inc.</strong> — servicio de envío de correo electrónico transaccional.</li>
          <li><strong>OpenAI / Anthropic</strong> — modelos de inteligencia artificial para las funciones de búsqueda y chat, únicamente cuando el Usuario los activa y configura con su propia clave de API.</li>
        </ul>
        <p>No cedemos datos personales a terceros con fines de marketing ni comerciales.</p>
      </section>

      <section>
        <h2>5. Derechos de los interesados</h2>
        <p>De conformidad con el RGPD y la LOPDGDD, el Usuario puede ejercer los siguientes derechos dirigiéndose a <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> o al domicilio social indicado, adjuntando copia de su documento de identidad:</p>
        <ul>
          <li><strong>Acceso</strong>: conocer qué datos personales tratamos sobre usted.</li>
          <li><strong>Rectificación</strong>: corregir datos inexactos o incompletos.</li>
          <li><strong>Supresión</strong>: solicitar la eliminación de sus datos cuando ya no sean necesarios.</li>
          <li><strong>Oposición</strong>: oponerse al tratamiento basado en interés legítimo o con fines de marketing.</li>
          <li><strong>Limitación del tratamiento</strong>: solicitar que suspendamos el tratamiento en determinadas circunstancias.</li>
          <li><strong>Portabilidad</strong>: recibir sus datos en un formato estructurado y legible por máquina.</li>
          <li><strong>Retirada del consentimiento</strong>: en cualquier momento, sin que ello afecte a la licitud del tratamiento anterior.</li>
        </ul>
        <p>Asimismo, tiene derecho a presentar una reclamación ante la <strong>Agencia Española de Protección de Datos (AEPD)</strong> si considera que el tratamiento de sus datos no es conforme a la normativa: <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer">www.aepd.es</a>.</p>
      </section>

      <section>
        <h2>6. Seguridad</h2>
        <p>La Empresa ha adoptado medidas técnicas y organizativas adecuadas para garantizar la seguridad e integridad de los datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado, teniendo en cuenta el estado de la tecnología, la naturaleza de los datos y los riesgos a los que están expuestos.</p>
      </section>

      <section>
        <h2>7. Modificaciones</h2>
        <p>La Empresa se reserva el derecho a actualizar esta Política de Privacidad para adaptarla a novedades legislativas o jurisprudenciales. Se comunicará al Usuario cualquier modificación relevante a través del correo electrónico asociado a su cuenta o mediante un aviso destacado en el Sitio.</p>
        <p><em>Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}</em></p>
      </section>
    </LegalLayout>
  );
}
